import React from 'react';
import HeroIMG from '../assets/hero-azf.png';
import Students from '../assets/students.png';

const Hero = () => (
  <section className="hero" id="home">
    <div className="heroOverlay">
          <div className="hero-badge">
            <span role="img" aria-label="book">📚</span> Empower Islamic Learning
          </div>
          <h1 className="heroTitle">
          Supporting the Seekers of <span className="heroHighlight">Islamic Knowledge</span>
        </h1>
        <p className="heroDesc">
          We give grants to committed students of advanced Islamic studies, helping keep traditional religious scholarship alive and growing.
        </p>
        <div className="heroActions">
          <a href="https://docs.google.com/forms/d/1eRGV-rcK4nzIKdE4zWMovypxxJat4Xhl5zP2A2vqtpQ/viewform?ts=6812c89d&edit_requested=true" className="btnPrimary">Apply for a Grant</a>
          <a href="#contact" className="btnSecondary">Donate Now</a>
        </div>
        <div className="heroSupporting">
          <div className="heroSupportingIcon" role="img" aria-label="hands">
            <img src={Students} alt="hands" className="heroSupportingImg" />
          </div>
          Supporting Students Worldwide</div>
    </div>
    <img src={HeroIMG} alt="Hero Background" className="heroBg" />
  </section>
);

export default Hero;
